/**
 * Data layer for `regional-data-residency-india-eu-us`. Thin typed fetch wrappers over /api/v1/regional-data-residency-india-eu-us.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface RegionalDataResidencyIndiaEuUsRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListRegionalDataResidencyIndiaEuUsResponse {
	count: number;
	items: RegionalDataResidencyIndiaEuUsRow[];
}

export interface CreateRegionalDataResidencyIndiaEuUsBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/regional-data-residency-india-eu-us";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListRegionalDataResidencyIndiaEuUsResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListRegionalDataResidencyIndiaEuUsResponse>(res);
}

export async function create(body: CreateRegionalDataResidencyIndiaEuUsBody): Promise<RegionalDataResidencyIndiaEuUsRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<RegionalDataResidencyIndiaEuUsRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const regionalDataResidencyIndiaEuUsQueryKeys = {
	all: ["regional-data-residency-india-eu-us"] as const,
	list: () => [...regionalDataResidencyIndiaEuUsQueryKeys.all] as const,
	detail: (id: string) => [...regionalDataResidencyIndiaEuUsQueryKeys.all, id] as const,
};
